exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".logos{position:fixed;top:0;right:0;left:0;padding-top:4rem}@media (min-width:48em){.logos{padding-top:7.5rem}}.logos .nav-bar-inner{position:relative}.logos .nav-bar-inner .logo-type-a{display:inline-block}.logos .nav-bar-inner .logo-type-a .logo-type{position:absolute;top:3.2rem;left:2.4rem;display:none;opacity:0;width:15rem;height:2rem}@media (min-width:48em){.logos .nav-bar-inner .logo-type-a .logo-type{top:4.75rem}}.logos .nav-bar-inner .logo-mark-a{display:inline-block}.logos .nav-bar-inner .logo-mark-a .logo-mark{width:8rem;height:8rem;margin:0 auto}@media (min-width:48em){.logos .nav-bar-inner .logo-mark-a .logo-mark{width:10.4rem;height:10.4rem}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/ui-Logos/_index.scss
 ** module id = 194
 ** module chunks = 0
 **/